import { render, staticRenderFns } from "./AvatarStyleNone.vue?vue&type=template&id=9b0fc46c&scoped=true"
import script from "./AvatarStyleNone.vue?vue&type=script&lang=js"
export * from "./AvatarStyleNone.vue?vue&type=script&lang=js"
import style0 from "./AvatarStyleNone.vue?vue&type=style&index=0&id=9b0fc46c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0fc46c",
  null
  
)

export default component.exports